<template>
	<div class="product-group">
		<search-product-type
			v-on:addProductType="addProductType"
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
			:search="search"
		>
		</search-product-type>
		<add-product-type
			v-on:cancel="cancel"
			:productType="productType"
			:dialogProductType="dialogProductType"
		>
		</add-product-type>
		<div class="vue-padding">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="productTypeList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="name"
					:show-overflow-tooltip="true"
					:label="$t('productType.name')"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="notes"
					:label="$t('productType.notes')"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:label="$t('productType.createTime')"
					width="160"
					:align="'center'"
				></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					:width="$i18n.locale == 'zh_CN' ? 85 : 100"
					:align="'center'"
				>
					<template slot-scope="scope">
						<el-button
							size="mini"
							v-hasPerm="['product:type:update']"
							@click="editProductType(scope.row)"
							>{{ $t("common.edit") }}</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				v-if="productTypeList.length > 0"
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import searchProductType from "_c/product/SearchProductType";
import addProductType from "_c/product/AddProductType";
export default {
	name: "ProductGroup",
	components: {
		searchProductType,
		addProductType,
	},
	data() {
		return {
			search: {
				name: "",
			},
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			productTypeList: [],
			loading: false,
			dialogProductType: false,
			productType: {
				id: "",
				name: "",
				notes: "",
			},
		};
	},
	mounted() {
		this.currentChange();
	},
	methods: {
		onSubmit(data) {
			this.search = data;
			this.currentChange();
		},
		resetSearch(data) {
			this.search = data;
			this.currentChange();
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.ProductType.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.productTypeList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		editProductType(row) {
			this.dialogProductType = true;
			Object.keys(this.productType).forEach(key => {
				this.productType[key] = row[key];
			});
			this.productType.id = row.id;
		},
		addProductType() {
			this.dialogProductType = true;
		},
		cancel(dialog, state) {
			this.dialogProductType = dialog;
			if (state) {
				this.currentChange(this.page.pageIndex);
			}
		},
		delProductType(row) {},
	},
};
</script>

<style>
.el-dialog__header {
	padding: 20px;
}
.el-dialog__body {
	padding: 0 20px;
	height: auto !important;
}
.el-dialog__footer {
	padding: 20px;
}
</style>
